import { assign, createMachine, Interpreter } from 'xstate-v4'

export type ResetPasswordConfirmationEvent =
  | { type: 'VALIDATE_TOKEN'; data: { token: string; uid: string } }
  | { type: 'SUBMIT' }
  | { type: 'CHANGE_PASSWORD'; value: string }

export interface ResetPasswordConfirmationContext {
  errors?: Record<string, string[]>
  password: string
  token: string
  uid: string
  email?: string
  next?: string
}

export function returnResetPasswordConfirmationMachine() {
  return createMachine<
    ResetPasswordConfirmationContext,
    ResetPasswordConfirmationEvent
  >(
    {
      context: {
        password: '',
        token: '',
        uid: '',
        next: '',
      },
      initial: 'idle',
      states: {
        idle: {
          on: {
            VALIDATE_TOKEN: {
              actions: assign({
                token: (_, { data }) => data.token,
                uid: (_, { data }) => data.uid,
              }),
              target: 'validatingToken',
            },
          },
        },
        validatingToken: {
          invoke: {
            src: 'validateToken',
            onDone: {
              target: 'tokenValid',
              actions: assign({
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access -- TODO: Type XState event.data properly
                email: (_, event) => event.data?.email || '',
              }),
            },
            onError: 'tokenError',
          },
        },
        tokenValid: {
          initial: 'normal',
          on: {
            SUBMIT: 'changing',
            CHANGE_PASSWORD: {
              actions: assign({
                password: (_, { value }) => value,
              }),
              target: 'tokenValid',
              internal: true,
            },
          },
          states: {
            normal: {
              onEntry: assign((_) => ({ errors: {} })),
            },
            errors: {},
          },
        },
        changing: {
          invoke: {
            src: 'changePassword',
            onDone: 'changed',
            onError: {
              actions: [
                'logError',
                assign({
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- TODO: Type XState event.data properly
                  errors: (_, { data }) => data,
                }),
              ],
              target: 'tokenValid.errors',
            },
          },
        },
        changed: {
          type: 'final',
        },
        tokenError: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        logError: () => {
          throw new Error(
            'resetPasswordConfirmationMachine logError not implemented',
          )
        },
      },
      services: {
        changePassword: () => {
          throw new Error('changePassword not implemented')
        },
        validateToken: () => {
          throw new Error('validateToken not implemented')
        },
      },
    },
  )
}

export type ResetPasswordConfirmationMachineInterpreter = Interpreter<
  ResetPasswordConfirmationContext,
  any,
  ResetPasswordConfirmationEvent
>
